import { render, staticRenderFns } from "./Rotate.vue?vue&type=template&id=5d8a91a8&scoped=true"
import script from "./Rotate.vue?vue&type=script&lang=js"
export * from "./Rotate.vue?vue&type=script&lang=js"
import style0 from "./Rotate.vue?vue&type=style&index=0&id=5d8a91a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8a91a8",
  null
  
)

export default component.exports